module.exports = __webpack_public_path__ + "media/images/icons/icon_close_red-f952ba40ee5199ea6397931c1f42b50f.svg";